import React from 'react'

type PlusIconProps = {
  width?: number | string
  height?: number | string
  className?: string
  color?: string
}

export const PlusIcon = ({ width = 20, height = 20, className, color = '#0A2B1F' }: PlusIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10 4.16667V15.8333M4.16667 10H15.8333"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
